module.exports = __webpack_public_path__ + "img/brazo-extensor-5.3f3a077e.png";